<template>
  <div>
    <Card>
      <ui-checkbox v-model="value" label="Simple checkbox"></ui-checkbox>
    </Card>
    <Card>
      <ui-checkbox
        v-model="value"
        label="Simple checkbox"
        help-tooltip="Help tooltip"
      ></ui-checkbox>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { ref } from 'vue';

const value = ref(false);
</script>
